<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <el-form-item label="筛选条件" prop="has_condition">
          <el-table
            :data="form.condition"
            style="width: 80%">
            <el-table-column
              prop="field_id"
              label="选择判断字段">
              <template scope="scope">
                <el-select v-model="scope.row.field_id" placeholder="请选择">
                  <el-option v-for="item in inputList" 
                  :label="item.name + '(' + item.title + ')' " 
                  :value="item.field_id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              label="判断类型">
              <template scope="scope">
                <el-select v-model="scope.row.type" placeholder="请选择">
                  <el-option
                    v-for="item in types"
                    :label="item.value"
                    :value="item.type">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="logic"
              label="逻辑">
              <template scope="scope">
                <el-select v-model="scope.row.logic" placeholder="请选择" v-if="scope.row.type == 10">
                  <el-option
                    v-for="item in logicTypes"
                    :key="item.type"
                    :label="item.value"
                    :value="item.type">
                  </el-option>
                </el-select>
                <span v-else>等于</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="value"
              label="值"
              width="180">
              <template scope="scope">
                <el-input placeholder="指标名称" v-model="scope.row.value" v-if="scope.row.type == 10"></el-input>
                <span v-else>登录ID</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="80">
              <template scope="scope">
                <el-button size="mini" @click.native.prevent="deleteRow(scope.$index, form.condition)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button @click="addRow" class="m-t-20">添加</el-button>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          condition: [],
          field_id: '',
          logic: '',
          value: ''
        },
        logicTypes: [
          { type: 10, value: '等于' },
          { type: 20, value: '不等于' },
          { type: 30, value: '大于' },
          { type: 40, value: '大于等于' },
          { type: 50, value: '小于' },
          { type: 60, value: '小于等于' },
          { type: 70, value: '含有' }
        ],
        types: [
          { type: 10, value: '常量' },
          { type: 20, value: '用户ID' }
        ],
        inputList: []
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.condition = res.data.config.condition
              this.form.field_id = res.data.config.field_id
              this.form.logic = res.data.config.logic
              this.form.value = res.data.config.value
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        let postData = {
          params: {
            type: 1
          }
        }
        this.apiGet(`form/models/${this.modelId}/fields`, postData).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      },
      addRow() {
        this.form.condition.push({
          field_id: '',
          logic: '',
          type: 10,
          value: ''
        })
      },
      deleteRow(index, rows) {
        rows.splice(index, 1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// filterConfig.vue?e0093f6a